import {GET_EXPERIENCE} from "../../../../enums/Profile/profile";

export const getExpirienceInformationAction = (data)=>{
    return{
        type:GET_EXPERIENCE,
        payload:data,
    };
};
